export default "__VITE_ASSET__BV1NRiOF__"